<template lang="pug">
    .sv-select-input-list
        .sv-select-input-list__container(
            v-for="(value, index) in valuesWithEmpty"
            :key="index"
        )
            .sv-select-input-list__number {{ index + 1 }}

            SvInput.sv-select-input-list__select(
                v-for="(input_name, input_index) in inputs"
                :key="input_name"
                color="graylight"
                :value="value[input_name]"
                :withIcon="false"
                @input="(v) => changeInputValue(v, index, input_name)"
                :placeholder="placeholders[input_index]"
            )

            SvButton.sv-select-input-list__remove(
                v-if="checkValues(value)"
                icon
                :prependIcon=`{
                icon: 'trash',
                width: 20,
                height: 20,
                default: '#B7BAC6',
                hover: '#1993EB'
            }`
                view="primary-icon"
                @click="remove(index)"
            )
</template>

<script>
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvInput from '@/components/uikit/SvInput.vue';

export default {
    name: 'SvMultipleInputsUni',

    data() {
        return {
            latitude: '',
            longitude: '',
            coordinatesString: '',
        }
    },

    components: {
        SvSelect,
        SvButton,
        SvInput,
    },

    model: {
        prop: 'values',
        event: 'change',
    },

    props: {
        // Список всех значений
        values: {
            type: Array,
            required: true,
        },

        inputs: {
            type: Array,
            default: [],
        },

		placeholders: {
            type: Array,
            default: [],
        },
    },

    computed: {
        valuesWithEmpty() {
			let obj = {};
			this.inputs.forEach(input_name => {
				obj[input_name] = '';
			});
			return [...this.values, obj];
        },
    },

    methods: {

        /*changeCoordinatesInput(value, index) {
            const copyValues = [...this.values];
            const currentValue = copyValues[index];
            copyValues.splice(index, 1, {
                ...currentValue,
                coordinatesString: value,
            });
            this.$emit('change', copyValues);
        },

        changeCoordinatesBlur(value, index) {
            const copyValues = [...this.values];
            const currentValue = copyValues[index];
            const coordinates = value.split(', ');

            copyValues.splice(index, 1, {
                ...currentValue,
                latitude: coordinates[0] || '',
                longitude: coordinates[1] || ''
            });
            this.$emit('change', copyValues);
        },*/

		changeInputValue(value, index, input_name) {
            const copyValues = [...this.values];
            const currentValue = copyValues[index];
			copyValues.splice(index, 1, {
                ...currentValue,
                [input_name]: value,
            });
            this.$emit('change', copyValues);
        },

        checkValues(value) {
            return Object.keys(value).filter(input_name => !!value[input_name]).length;
        },

        remove(index) {
            const temp = this.values.slice();
            temp.splice(index, 1);
            this.$emit('change', temp);
        },
    },
};
</script>

<style lang="scss" scoped>
.sv-select-input-list__container {
    margin-bottom: 15px;

    &:last-child {
        margin-bottom: 0;
    }
}

.sv-select-input-list {
    &--with-remove {
        // margin-bottom: 15px;
    }

    &__container {
        display: flex;
    }

    &__select {
        width: 200px;
        margin-right: 10px;
    }

    &__input {
        width: calc(100% - 50px - 170px);
        margin-right: 10px;
    }
}

.sv-select-input-list__number {
    margin-right: 10px;
    line-height: 40px;
}
</style>
